import { FCWithChildren } from 'common/types';

import Checklist from './components/Checklist/Checklist';
import UploadZone from './components/UploadZone/UploadZone';
import OBUploadContext, { OBUploadContextType } from './lib/context';

type OBUploadProps = Pick<
  OBUploadContextType,
  'onSuccessfulUpload' | 'uploadFile'
>;

type OBUploadType = FCWithChildren<OBUploadProps> & {
  UploadZone: typeof UploadZone;
  Checklist: typeof Checklist;
};

/**
 * A helper component to compose uploaders in the onboarding.
 */
const OBUpload: OBUploadType = ({
  children,
  onSuccessfulUpload,
  uploadFile,
}) => (
  <OBUploadContext.Provider
    value={{
      onSuccessfulUpload,
      uploadFile,
    }}
  >
    {children}
  </OBUploadContext.Provider>
);

OBUpload.UploadZone = UploadZone;
OBUpload.Checklist = Checklist;

export default OBUpload;
